import MUITableFooter from '@mui/material/TableFooter';
import React from 'react';

import { propsMapper } from '~/common/components/PropertyMappers/propsMapper';

type TfootProps = {
  children?: React.ReactNode;
  classes?: any;
  component?: React.ReactNode;
  sx?: any;
};

const Tfoot = React.forwardRef<any, TfootProps>(
  ({ children, ...props }, ref) => {
    return (
      <MUITableFooter ref={ref} {...propsMapper(props)}>
        {children}
      </MUITableFooter>
    );
  },
);

Tfoot.displayName = 'Tfoot';

export default Tfoot;
